module.exports = __webpack_public_path__ + "img/icon-white-37.bbda0469.svg";